<template>
  <div>
    <div class="p-4 bg-gray-200 rounded shadow w-full mb-6 flex">
      <div>
        <input class="input mr-2" v-model="invoiceNumberFilter" placeholder="Rechnungsnummer" @change="fetchData()"/>
      </div>
      <div>
        <input class="input mr-2" v-model="invoiceNameFilter" placeholder="Rechnungsname" @change="fetchData()"/>
      </div>
      <div>
        Status:
        <template v-for="state in this.states">
          <button @click="setStateFilter(state.name)" class="mx-1 btn-small btn" v-bind:class="stateClass(state.name)">
            {{ state.human_readable }}
          </button>
        </template>
        <button @click="setStateFilter('')" class="mx-1 btn-small btn" v-bind:class="stateClass('')">alle</button>
      </div>
    </div>
    <table class="table-auto shadow rounded w-full mb-20">
      <tr class="bg-gray-200">
        <th class="px-4 py-2 text-gray-600 uppercase text-sm text-left">Nr</th>
        <th class="px-4 py-2 text-gray-600 uppercase text-sm text-left">Vorgang</th>
        <th class="px-4 py-2 text-gray-600 uppercase text-sm text-left">Rechnungsname</th>
        <th class="px-4 py-2 text-gray-600 uppercase text-sm text-right">Netto</th>
        <th class="px-4 py-2 text-gray-600 uppercase text-sm text-right">Brutto</th>
        <th class="px-4 py-2 text-gray-600 uppercase text-sm text-right">Offen</th>
        <th class="px-4 py-2 text-gray-600 uppercase text-sm text-left">Status</th>
      </tr>
      <tr class="font-bold border-t border-gray">
        <td class="px-4 py-2">Gesamt</td>
        <td class="px-4 py-2"></td>
        <td class="px-4 py-2"></td>
        <td class="px-4 py-2 text-right">{{ calculateTotal() | toCurrency }}</td>
        <td class="px-4 py-2 text-right">{{ calculateTotalWithTax() | toCurrency }}</td>
        <td class="px-4 py-2 text-right">{{ calculateOpenAmount() | toCurrency }}</td>
        <td class="px-4 py-2"></td>
      </tr>
      <tr v-for="invoice in this.invoices">
        <td class="px-4 py-2 border-dashed border-t border-gray-200 text-left whitespace-no-wrap">
          <a :href="invoice.html_path" class="primary-link">
            <i class="fas fa-receipt"></i> {{ invoice.invoice_number }}
          </a>
        </td>
        <td class="px-4 py-2 border-dashed border-t border-gray-200 text-left">
          <a :href="invoice.dossier_path" class="primary-link">
            <i class="fas fa-folder-open"></i> {{ invoice.dossier_name }}
          </a>
        </td>
        <td class="px-4 py-2 border-dashed border-t border-gray-200 text-left whitespace-no-wrap">
          <a :href="invoice.html_path" class="primary-link">
            {{ invoice.invoice_name }}
          </a>
        </td>
        <td class="px-4 py-2 border-dashed border-t border-gray-200 text-right">
          {{ invoice.total_amount | toCurrency }}
        </td>
        <td class="px-4 py-2 border-dashed border-t border-gray-200 text-right">
          {{ invoice.total_amount_with_tax | toCurrency }}
        </td>
        <td class="px-4 py-2 border-dashed border-t border-gray-200 text-right">
          {{ invoice.open_amount | toCurrency }}
        </td>
        <td class="px-4 py-2 border-dashed border-t border-gray-200 text-left">
          <span class="mx-1 btn-small btn btn-primary whitespace-no-wrap">{{ invoice.state_human_readable }}</span>
        </td>
      </tr>
      <tr class="font-bold border-t border-gray">
        <td class="px-4 py-2">Gesamt</td>
        <td class="px-4 py-2"></td>
        <td class="px-4 py-2"></td>
        <td class="px-4 py-2 text-right">{{ calculateTotal() | toCurrency }}</td>
        <td class="px-4 py-2 text-right">{{ calculateTotalWithTax() | toCurrency }}</td>
        <td class="px-4 py-2 text-right">{{ calculateOpenAmount() | toCurrency }}</td>
        <td class="px-4 py-2"></td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: ['states'],
  data() {
    return {
      invoiceNumberFilter: '',
      invoiceNameFilter: '',
      stateFilter: 'open',
      invoices: [],
    }
  },
  filters: {
    toCurrency: function(value) {
      if (typeof value !== "number") {
        return value;
      }
      var formatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
      });
      return formatter.format(value);
    }
  },
  methods: {
    calculateTotal() {
      return this.invoices.map(i => i.total_amount).reduce((a, b) => a + b, 0)
    },
    calculateTotalWithTax() {
      return this.invoices.map(i => i.total_amount_with_tax).reduce((a, b) => a + b, 0)
    },
    calculateOpenAmount() {
      return this.invoices.map(i => i.open_amount).reduce((a, b) => a + b, 0)
    },
    stateClass: function (state) {
      return {
        'btn-secondary': this.stateFilter != state,
        'btn-primary': this.stateFilter == state,
      }
    },
    setStateFilter: function (state) {
      this.stateFilter = state
      this.fetchData()
    },
    fetchData: function () {
      this.$http['get']('/invoices.json', {
        params: {
          state: this.stateFilter,
          invoice_number: this.invoiceNumberFilter,
          invoice_name: this.invoiceNameFilter,
        }
      }).then(response => {
        console.log(response.body)
        this.invoices = response.body
        this.$forceUpdate()
      }, response => {
        console.log(response)
      })
    }
  },
  mounted() {
    this.fetchData();
  }
}
</script>